import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { useToaster } from '~/composables/_next/useToaster';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { ADD_WISHLIST_DRAFT } from '~/constants/recipesConstants';
import { useProductWishlistStore } from '~/composables/_next/stores/useProductWishlistStore';
export default /*#__PURE__*/_defineComponent({
  __name: 'WishlistButton',
  props: {
    masterVariantSku: null,
    productId: null,
    productName: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useProductWishlistSt = useProductWishlistStore(),
      removeProductFromWishlist = _useProductWishlistSt.removeProductFromWishlist,
      addProductToWishlist = _useProductWishlistSt.addProductToWishlist,
      productWishlist = _useProductWishlistSt.productWishlist,
      fetchProductWishlist = _useProductWishlistSt.fetchProductWishlist,
      checkProductInWishlist = _useProductWishlistSt.checkProductInWishlist;
    var _useToaster = useToaster(),
      showToast = _useToaster.show;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      doActionOrLogin = _useAuthenticatedActi.doActionOrLogin;
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      i18n = _useNuxt2App.i18n,
      $trackers = _useNuxt2App.$trackers,
      $sentry = _useNuxt2App.$sentry,
      api = _useNuxt2App.$vsf.$ct.api;
    var pageUrl = (route === null || route === void 0 ? void 0 : route.fullPath) || '';
    var loading = ref(false);
    var isFavorite = computed(function () {
      return checkProductInWishlist(props.productId);
    });

    /**
     * Toggles the wishlisted status of the current product
     */
    function toggleAddToWishlist() {
      try {
        loading.value = true;
        if (isFavorite.value) {
          doActionOrLogin({
            nextRoutePath: route.path,
            previousRoutePath: route.path,
            action: handleRemoveProductFromWishlist
          });
        } else {
          doActionOrLogin({
            nextRoutePath: route.path,
            previousRoutePath: route.path,
            action: handleAddProductToWishlist
          });
        }
      } catch (error) {
        loading.value = false;
        showToast({
          title: i18n.t('wishlist-button.toast.error')
        }, 2000);
      }
    }

    /**
     * Removes the product from wishlist.
     */
    function handleRemoveProductFromWishlist() {
      return _handleRemoveProductFromWishlist.apply(this, arguments);
    }
    /**
     * Creates and load a wishlist if not present.
     */
    function _handleRemoveProductFromWishlist() {
      _handleRemoveProductFromWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _productWishlist$valu, _productWishlist$valu2;
        var wishlistProduct, _wishlistProduct$vari;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              wishlistProduct = (_productWishlist$valu = productWishlist.value) === null || _productWishlist$valu === void 0 ? void 0 : (_productWishlist$valu2 = _productWishlist$valu.lineItems) === null || _productWishlist$valu2 === void 0 ? void 0 : _productWishlist$valu2.find(function (item) {
                return (item === null || item === void 0 ? void 0 : item.productId) === props.productId;
              });
              if (!wishlistProduct) {
                _context.next = 19;
                break;
              }
              _context.prev = 2;
              loading.value = true;
              _context.next = 6;
              return removeProductFromWishlist(wishlistProduct.id);
            case 6:
              $trackers.gtm.pushEvent('remove_from_wishlist', {
                event_category: 'ecommerce',
                event_label: 'remove_from_wishlist',
                event_name: 'remove_from_wishlist',
                product_name: (props === null || props === void 0 ? void 0 : props.productName) || '',
                product_id: (wishlistProduct === null || wishlistProduct === void 0 ? void 0 : (_wishlistProduct$vari = wishlistProduct.variant) === null || _wishlistProduct$vari === void 0 ? void 0 : _wishlistProduct$vari.sku) || '',
                page_url: pageUrl
              });
              showToast({
                title: i18n.t('wishlist-button.toast.removed'),
                iconName: 'checkmark'
              }, 2000);
              _context.next = 16;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);
              console.error(_context.t0);
              $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('product', {
                id: props.productId,
                name: props.productName
              });
              $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(_context.t0);
              showToast({
                title: i18n.t('wishlist-button.toast.error')
              }, 2000);
            case 16:
              _context.prev = 16;
              loading.value = false;
              return _context.finish(16);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 10, 16, 19]]);
      }));
      return _handleRemoveProductFromWishlist.apply(this, arguments);
    }
    function createAndLoadWishlistIfNotPresent() {
      return _createAndLoadWishlistIfNotPresent.apply(this, arguments);
    }
    /**
     * Adds the product to wishlist.
     */
    function _createAndLoadWishlistIfNotPresent() {
      _createAndLoadWishlistIfNotPresent = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var draft;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (productWishlist.value) {
                _context2.next = 7;
                break;
              }
              draft = ADD_WISHLIST_DRAFT;
              draft.name[0].value = 'favoris';
              _context2.next = 5;
              return api.createShoppingList(draft);
            case 5:
              _context2.next = 7;
              return fetchProductWishlist(true);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _createAndLoadWishlistIfNotPresent.apply(this, arguments);
    }
    function handleAddProductToWishlist() {
      return _handleAddProductToWishlist.apply(this, arguments);
    }
    function _handleAddProductToWishlist() {
      _handleAddProductToWishlist = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (props.masterVariantSku) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              _context3.next = 4;
              return createAndLoadWishlistIfNotPresent();
            case 4:
              if (!checkProductInWishlist(props.productId)) {
                _context3.next = 7;
                break;
              }
              loading.value = false;
              return _context3.abrupt("return");
            case 7:
              _context3.prev = 7;
              loading.value = true;
              _context3.next = 11;
              return addProductToWishlist(props.productId);
            case 11:
              $trackers.gtm.pushEvent('add_to_wishlist', {
                event_category: 'ecommerce',
                event_label: 'add_to_wishlist',
                event_name: 'add_to_wishlist',
                product_name: (props === null || props === void 0 ? void 0 : props.productName) || '',
                product_id: (props === null || props === void 0 ? void 0 : props.masterVariantSku) || '',
                page_url: pageUrl
              });
              showToast({
                title: i18n.t('wishlist-button.toast.added'),
                iconColor: 'var(--c-secondary-purple-900)',
                iconName: 'heart_filled'
              }, 2000);
              _context3.next = 21;
              break;
            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](7);
              console.error(_context3.t0);
              $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('product', {
                id: props.productId,
                name: props.productName
              });
              $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(_context3.t0);
              showToast({
                title: i18n.t('wishlist-button.toast.error')
              }, 2000);
            case 21:
              _context3.prev = 21;
              loading.value = false;
              return _context3.finish(21);
            case 24:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[7, 15, 21, 24]]);
      }));
      return _handleAddProductToWishlist.apply(this, arguments);
    }
    return {
      __sfc: true,
      props: props,
      removeProductFromWishlist: removeProductFromWishlist,
      addProductToWishlist: addProductToWishlist,
      productWishlist: productWishlist,
      fetchProductWishlist: fetchProductWishlist,
      checkProductInWishlist: checkProductInWishlist,
      showToast: showToast,
      doActionOrLogin: doActionOrLogin,
      route: route,
      i18n: i18n,
      $trackers: $trackers,
      $sentry: $sentry,
      api: api,
      pageUrl: pageUrl,
      loading: loading,
      isFavorite: isFavorite,
      toggleAddToWishlist: toggleAddToWishlist,
      handleRemoveProductFromWishlist: handleRemoveProductFromWishlist,
      createAndLoadWishlistIfNotPresent: createAndLoadWishlistIfNotPresent,
      handleAddProductToWishlist: handleAddProductToWishlist,
      AzButton: AzButton,
      AzIcon: AzIcon
    };
  }
});